import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Stack, Text, useToast } from "@chakra-ui/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { adminDeleteSuspend } from "../../../api";
import { colors } from "../../../styles";
import { formatDateTimeKor } from "../../../utils";

interface SuspendModalProps {
    isOpen: boolean;
    onClose: () => void;
    profileId: string;
    suspendId: string;
    reason: string;
    isLifted: boolean;
    createdAt: string;
}

export default function SuspendModal(props: SuspendModalProps) {

    const queryClient = useQueryClient();
    const toast = useToast();

    const deleteSuspendMutation = useMutation({
        mutationFn: adminDeleteSuspend,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['adminGetProfiles'] });
            props.onClose();
            toast({
                title: "정지를 취소했습니다.",
                status: "success",
                position: "top",
                duration: 2000,
                isClosable: true,
            });
        },
        onError: (error) => {
            console.error(error);
            toast({
                title: "정지 취소에 실패했습니다.",
                status: "error",
                position: "top",
                duration: 2000,
                isClosable: true,
            });
        },
    });

    const onDeleteSuspend = () => {
        deleteSuspendMutation.mutate({ profileId: props.profileId, suspendId: props.suspendId });
    };

    return (
        <Modal isOpen={props.isOpen} onClose={props.onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    <Text fontSize={20} fontWeight={700} color={colors.black}>정지 상세</Text>
                    <ModalCloseButton />
                </ModalHeader>
                <ModalBody>
                    <Stack gap={3}>
                        <Text fontSize={14} fontWeight={400} color={colors.gray}>
                            생성 시각
                        </Text>
                        <Text fontSize={16} fontWeight={400} color={colors.black}>
                            {formatDateTimeKor(props.createdAt)}
                        </Text>
                        <Text fontSize={14} fontWeight={400} color={colors.gray}>
                            정지 사유
                        </Text>
                        <Text fontSize={16} fontWeight={400} color={colors.black} whiteSpace="pre-wrap">
                            {props.reason || "-"}
                        </Text>
                        <Text fontSize={14} fontWeight={400} color={colors.gray}>
                            정지 상태
                        </Text>
                        <Text fontSize={16} fontWeight={400} color={colors.black}>
                            {props.isLifted ? "해제됨" : "해제 안됨"}
                        </Text>
                    </Stack>
                </ModalBody>
                <Stack marginTop={5} width={"100%"} padding={3}>
                    <Button
                        onClick={onDeleteSuspend}
                        isLoading={deleteSuspendMutation.isPending}
                        isDisabled={props.isLifted}
                        width={"100%"}
                        backgroundColor={props.isLifted ? colors.gray : colors.apple}
                        color={colors.white}
                        borderRadius={10}
                        _hover={{ bg: colors.apple }}
                        boxShadow="sm"
                    >
                        취소
                    </Button>
                </Stack>
            </ModalContent>
        </Modal>
    );
}
